export enum YmGoal {
  View = 'testo_view',
  Start = 'testo_start',
  Question = 'testo_question',
  Result = 'testo_result',
  Finish = 'testo_finish',
  ClickShowAnswers = 'testo_click_show_answers',
}
